<template>
  <div class="page-with-top-bar">
    <section>
      <div class="mt-4">
        <b-tabs class="epc-tabs" v-model="mainActiveTab">
          <!-- Generar informe: x-elio usa su formulario; el resto, el clásico (legacy) -->
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="file-alt"></b-icon>
              <span> {{ $t('generate_report') }} </span>
            </template>
            <div>
              <ReportGenerateFormXelio v-if="isXelio" ref="xelioForm" @refresh-history="onRefreshHistory" />
              <ReportGenerateForm v-else ref="formGenerateReport"
                :type-report="typeReport"
                @refresh-history="onRefreshHistory"
              />
            </div>
          </b-tab-item>

          <!-- Histórico de informes -->
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="history"></b-icon>
              <span> {{ $t('report_history') }} </span>
            </template>
            <div>
              <HistoryReports ref="historyReports"
                :project-id="project.id"
                @load-report="onLoadReport"/>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ReportGenerateForm from './reports/detailed/views/report-generate-form.vue';
import ReportGenerateFormXelio from './reports/detailed/views/report-generate-form-xelio.vue';
import HistoryReports from './reports/detailed/views/history-reports.vue';

export default {
  middleware: 'auth',
  title: 'report_generation',
  subtitle: 'report_generation_subtitle',
  menuOption: '2-1',

  components: {
    ReportGenerateForm,
    ReportGenerateFormXelio,
    HistoryReports,
  },

  computed: {
    ...mapGetters({
      navData: 'app/navData',
      project: 'app/project',
      company: 'app/company',
    }),
    // En "Generar informe", x-elio carga su formulario propio; el resto, el clásico (legacy).
    isXelio() {
      return !!this.company && this.company.alias === 'x-elio'
    },
  },

  data: () => ({
    project_id: null,
    typeReport: null,
    mainActiveTab: 0
  }),

  created() {
    // this.$options.subtitle = ['project_actions_page_subtitle', [this.navData.project_name.toUpperCase()]]
    this.typeReport = typeof this.$route.query.type === 'undefined' ? null : this.$route.query.type
    this.project_id = this.project.id
  },

  methods: {
    onRefreshHistory() {
      this.$refs.historyReports.reload()
    },

    onLoadReport(report) {
      // Cargar un informe guardado va al tab "Generar informe" y se delega en el form activo:
      // el x-elio o el clásico según la empresa (ambos exponen LoadReport).
      this.mainActiveTab = 0;
      this.$nextTick(() => {
        const form = this.isXelio ? this.$refs.xelioForm : this.$refs.formGenerateReport;
        if (form && form.LoadReport) form.LoadReport(report)
      })
    }
  },
};

</script>
